import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { BaseFilterParams } from 'dashboard/lib/interfaces/BaseFilterParams';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { ReportRun } from 'dashboard/models/report-run';
import { clearReportRuns, setReportRuns } from 'dashboard/redux/actions/report-runs';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export interface ReportRunsFilterParams extends BaseFilterParams {
  reportTemplateVersionIds: string[];
}

export function clearReportRunsCustomList(currentEnvironment: Environment) {
  return async (dispatch: Dispatch) => {
    dispatch(clearReportRuns(currentEnvironment));
  };
}

// Note: Only loads CustomList type report runs for now
export function loadReportRunsCustomList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
  sortParams,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  sortParams: SortParams;
  filters: ReportRunsFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const params = createParamsForList(currentEnvironment, filters, sortParams);
    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const response = await SessionClientDashboard.listResource<ReportRun, PaginationParams>(
      ApiEndpoint.ReportRunsCustomList,
      paramsFull,
    );

    const runs = response.data;
    const paginationParams = response.meta;

    dispatch(setReportRuns(runs, currentEnvironment, paginationParams));
  };
}

function createParamsForList(
  currentEnvironment: Environment,
  filters: ReportRunsFilterParams,
  sortParams: SortParams,
) {
  return {
    filter: {
      'environment-id': currentEnvironment.id,
      'report-template-version-ids': filters.reportTemplateVersionIds,
    },
    sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
  };
}
